import { Observable } from 'rxjs';
import { LocationInfo } from 'src/cordovaPlugins/Location';

import { LOCATION_TRACKING_TYPES } from '../../../constants';
import { appServices } from '../../../singletons';

export function requestPermissions(): Observable<boolean> {
  console.log('requestPermissions called', appServices.permissions$);
  return appServices.permissions$
    .do((p) => console.debug('requestPermissions.permissions', p))
    .mergeMap((permissions) => {
      if (
        (permissions.location.canRequestInUse ||
          permissions.location.canRequestBackground) &&
        !permissions.location.inUse
      ) {
        console.log('requestPermissions going to request permissions');
        return appServices.permissionFunctions.requestLocationBackgroundPermission();
      }
      if (
        !permissions.location.inUse &&
        !permissions.location.canRequestBackground &&
        permissions.location.canReRequest
      ) {
        console.log(
          'requestPermissions going to request permissions via settings',
        );
        return appServices.permissionFunctions.askForLocationPermissionsAfterDenial(); // ask for more, still
      }

      return Promise.resolve(permissions.location.inUse);
    })
    .do((p) => console.debug('requestPermissions.result', p));
}

export function requestHighAccuracy(): Promise<boolean> {
  console.log('requestHighAccuracy called', appServices.permissions$);
  return appServices.permissions$
    .do((p) => console.debug('requestHighAccuracy.permissions', p))
    .mergeMap(() => {
      return appServices.permissionFunctions.requestHighAccuracyLocationPermission();
    })
    .do((p) => console.debug('requestHighAccuracy.result', p))
    .take(1)
    .toPromise();
}

export function waitForGps(): Promise<LocationInfo> {
  return appServices.location$
    .do((l) => console.log('waitForGps', l))
    .filter((l) => l.source === LOCATION_TRACKING_TYPES.GPS)
    .do((l) => console.log('waitForGps has new coords', l))
    .take(1)
    .timeout(10 * 1000)
    .toPromise();
}
